import {RolesAPI} from "../api/RolesAPI";
import {Role} from "../models/Role";
import {BaseService} from "./BaseService";
import {ErrorService} from "./ErrorService";
import {
	actionRoleFetchAllCompleted,
	actionRoleFetchCompleted,
	actionRoleSaveCompleted,
	actionRoleDeleteCompleted,
	actionDeleteRolesCompleted
} from "../store/roles/actions";
import {actionDeleteTabForItemId,
	actionSetTabItem,
	actionSetTabStateItem
} from "../store/tabs/actions";
import {actionToastrInfo} from "../store/global";

export default class RolesService extends BaseService {

	static getAll() {
		let rolesAPI: RolesAPI = new RolesAPI()
		rolesAPI.getAll().then(RolesService.processResponse).then(
			(data) => {
				actionRoleFetchAllCompleted(RolesService.responseToRoles(data))
			}
		).catch(error => ErrorService.handleError(error))
	}

	static save(role: Role) {
		let rolesAPI: RolesAPI = new RolesAPI()
		if (role.id) {
			rolesAPI.put(RolesService.roleToRequest(role)).then(RolesService.processResponse)
			.then((data) => {
				actionRoleSaveCompleted(RolesService.responseToRole(data))
				actionSetTabStateItem(RolesService.responseToRole(data))
				actionSetTabItem(RolesService.responseToRole(data))
				actionToastrInfo("Info", "Rola je uspešno snimljena")
			})
			.catch(error => ErrorService.handleError(error))
		} else {
			rolesAPI.post(RolesService.roleToRequest(role)).then(RolesService.processResponse)
				.then((data) => {
					actionRoleSaveCompleted(RolesService.responseToRole(data))
					actionSetTabItem(RolesService.responseToRole(data))
					actionSetTabStateItem(RolesService.responseToRole(data))
					actionToastrInfo("Info", "Rola je uspešno snimljena")
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static getOne (role: Role) {
		const rolesAPI: RolesAPI = new RolesAPI()
		rolesAPI.get(role).then(RolesService.processResponse)
		.then((data) => {
			actionRoleFetchCompleted(RolesService.responseToRole(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static delete(role: Role) {
		const rolesAPI: RolesAPI = new RolesAPI()
		rolesAPI.delete(role).then(RolesService.processResponse).then(
			(data) => {
				actionRoleDeleteCompleted(role)
				actionDeleteTabForItemId(role.id)
			}
		).catch(error => {ErrorService.handleError(error)})
	}

	static deleteRoles(roles: Role[]) {

		const rolesAPI: RolesAPI = new RolesAPI()
		let count = 0;
		roles.forEach(role => {

			rolesAPI.delete(RolesService.roleToRequest(role)).then(RolesService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(role.id)
					if(count === roles.length)
						actionDeleteRolesCompleted(roles)
				}
			).catch(error => {ErrorService.handleError(error)})
		});
	}

	static responseToRole (data: any): Role {
		let role = new Role()
		role.id = data.id
		role.name = data.name
		role.permissions = data.permissions
		role.documentPermissions = data.documentPermissions
		role.alias = data.alias
		return role
	}

	static responseToRoles (data: any) {
		return data
	}

	static roleToRequest (role: Role): any {
		return role
	}
}
